import { combineReducers } from "redux";
import creditLimitReducer from "./creditLimitReducer";
import translationsReducer from "./translationsReducer";
import authReducer from "./authReducer";
import customerDataReducer from "./customerDataReducer";
import ordersReducer from "./ordersReducer";
import orderDetailsReducer from "./orderDetailsReducer";
import duePaymentsReducer from "./duePaymentsReducer";
import ticketsReducer from "./ticketsReducer";
import orderTypesReducer from "./orderTypesReducer";

export default combineReducers({ 
  creditLimitReducer,
  translationsReducer,
  authReducer,
  customerDataReducer,
  ordersReducer,
  orderDetailsReducer,
  duePaymentsReducer,
  ticketsReducer,
  orderTypesReducer
});
